import { render, staticRenderFns } from "./Depsimulation.vue?vue&type=template&id=4f0810a5&scoped=true&"
import script from "./Depsimulation.vue?vue&type=script&lang=js&"
export * from "./Depsimulation.vue?vue&type=script&lang=js&"
import style0 from "./Depsimulation.vue?vue&type=style&index=0&id=4f0810a5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0810a5",
  null
  
)

export default component.exports